import { z } from 'zod';

export const createSchema = z.object({
  display_name: z.string({ message: 'Campo obrigatório' }).min(3, { message: 'Tamanho minimo: 3 characteres' }).max(64, { message: 'Tamanho máximo: 64 characteres' }),
  observations: z.string().min(8, { message: 'Tamanho minimo: 8 characteres' }),
  general_information: z.object({
    cnpj: z.string({ message: 'Campo obrigatório' }).refine((value) => value.length === 14 || value.length === 18, {message: 'Insira um CNPJ/CPF válido'}),
  }),
  contacts: z.object({
    full_name: z.string({ message: 'Campo obrigatório' }).min(3, { message: 'Tamanho minimo: 3 characteres' }).max(64, { message: 'Tamanho máximo: 64 characteres' }),
    role_in_company: z.string().optional(),
    email: z.string().min(1, 'Campo e-mail é obrigatório').email('Use um formato de e-mail válido'),
    phone: z.object({
      number: z.string().min(1, {message: 'Campo obrigatório'}),
      kind: z.null().optional(),
      whatsapp_capability: z.null().optional()
    }),
  })
})

export type PrivateClientsFunnelValidationSchema = z.infer<typeof createSchema>
